{
  "loading": "載入中…",
  "save": "儲存",
  "saving": "儲存中…",
  "cancel": "取消",
  "close": "關閉",
  "confirm": "確認",
  "back": "返回",
  "next": "下一步",
  "search": "搜尋",
  "filter": "篩選",
  "clear": "清除",
  "viewAll": "查看全部",
  "retry": "再試一次",
  "yes": "是",
  "no": "否",
  "none": "無",
  "empty": "暫時沒有內容",
  "saved": "已儲存",
  "language": "語言",
  "languageDescription": "選擇 BidNova Auctions 使用的語言，包括電郵及通知。",
  "languageSaved": "語言已更新",
  "loadingLabel": "載入中",
  "retrying": "重試中…",
  "nothingToShow": "暫時沒有內容。",
  "errorTitle": "發生問題",
  "errorBody": "目前無法載入內容。",
  "viewOrder": "查看訂單",
  "signIn": "登入",
  "signOut": "登出"
}
